<template>
  <div style="margin:1rem;">
    <b-row style="margin:0" v-if="at_step != 'done'">
      <b-col :step="step_plan" sm="3" style="position:relative;padding:0;"
         @click="usr_jump_to('plan')"
        >
        <svg width="100%" height="40px"
          viewBox="0 0 140 40" preserveAspectRatio="none">
          <path d="M   0   0
                   L   0  40
                   L 120  40
                   L 140  20
                   L 120   0
                   Z"/>
        </svg>
        <div class="step_txt"
         >
        Select Trial
        </div>
      </b-col>
      <b-col :step="step_room" sm="3" style="position:relative;padding:0;"
         @click="usr_jump_to('room')"
        >
        <svg width="100%" height="40px"
          viewBox="0 0 140 40" preserveAspectRatio="none">
          <path d="M   0   0
                   L  20  20
                   L   0  40
                   L 120  40
                   L 140  20
                   L 120   0
                   Z"/>
        </svg>
        <div class="step_txt">
          Choose Room
        </div>
      </b-col>
      <b-col :step="step_user" sm="3" style="position:relative;padding:0;"
         @click="usr_jump_to('user')"
        >
        <svg width="100%" height="40px"
          viewBox="0 0 140 40" preserveAspectRatio="none">
          <path d="M   0   0
                   L  20  20
                   L   0  40
                   L 120  40
                   L 140  20
                   L 120   0
                   Z"/>
        </svg>
        <div class="step_txt">
          User Info
        </div>
      </b-col>
      <b-col :step="step_pay" sm="3" style="position:relative;padding:0;"
         @click="usr_jump_to('pay')"
        >
        <svg width="100%" height="40px"
          viewBox="0 0 140 40" preserveAspectRatio="none">
          <path d="M   0   0
                   L  20  20
                   L   0  40
                   L 140  40
                   L 140   0
                   Z"/>
        </svg>
        <div class="step_txt">
          Payment
        </div>
      </b-col>
    </b-row>

    <b-row v-if="at_step == 'plan'" class="mt-4">
     <b-col style="margin:auto;">
      <b-card-group deck style="justify-content:center;">

      <b-card bg-variant="white"         
         text-variant="black" style="border-radius:1rem;max-width:30rem;"
         class="text-center">
        <b-card-text style="margin-bottom:4rem;">
          <b-row>
            <b-col>
              <h1 class="plan">
                TRIAL
              </h1>
            </b-col>
          </b-row>  
          <b-row class="mb-4">
            <b-col>
              <span class="per">
                FREE
              </span>
              <span class="per" style="font-size:0.8rem">
                30 days
              </span>
            </b-col>
          </b-row>  
          <b-row class="mb-1">
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> Up to 10 interactive participants. </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> Unlimited meetings. </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> Live streaming to Facebook, YouTube, Twitch and RTMP endpoint concurrently. </b-col>
          </b-row>
          <b-row>
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> Up to 3 breakout Rooms. </b-col>
          </b-row>
          <b-row>
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> Cloud recording and 1GB storage. </b-col>
          </b-row>
          <b-row class="mt-2 mb-1">
            <b-col sm="2" class="check"></b-col>
            <b-col sm="10" class="pbull">
                <a style="font-weight:600" href="https://videocafe.live/features.html"> Complete feature list </a>
            </b-col>
          </b-row>
        </b-card-text>
        <b-row class="selrow" v-if="user.plan">
         <b-col>
          <b-button v-if="!user.plan.name"
           style="width:60%"
           variant="primary"
           @click="pselect('trial')"
          >
           Select
          </b-button>
          <b-button v-if="user.plan.name == 'trial'"
           style="width:60%"
           variant="primary"
           disabled
          >
           <div> Your Current Plan </div>
          </b-button>
         </b-col>
        </b-row>
      </b-card>

      <b-card bg-variant="white" v-if="stripe_plans['basic']"
         text-variant="black" style="border-radius:1rem;max-width:30rem;"
         class="text-center">
        <b-card-text style="margin-bottom:4rem;">
          <b-row>
            <b-col>
              <h1 class="plan">
                BASIC
              </h1>
            </b-col>
          </b-row>  
          <b-row class="mb-4">
            <b-col>
              <span class="price">
                $11.99
              </span>
              <span class="per">
                /mo
              </span>
            </b-col>
          </b-row>  
          <b-row class="mb-1">
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> All of the Trial features with up to 100 interactive participants.</b-col>
          </b-row>
          <b-row>
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> Up to 15 breakout rooms and 4GB storage. </b-col>
          </b-row>
        </b-card-text>
        <b-row class="selrow" v-if="user.plan">
         <b-col>
          <b-button v-if="!user.plan.name || user.plan.name == 'cancel'"
           style="width:60%"
           variant="primary"
           @click="pselect('basic')"
          >
           Select
          </b-button>
          <b-button v-if="user.plan.name == 'trial'"
           style="width:60%"
           variant="primary"
           @click="pselect('basic')"
          >
           Upgrade
          </b-button>
          <b-button v-if="user.plan.name == 'basic'"
           style="width:60%"
           variant="primary"
           disabled
          >
           <div> Your Current Plan </div>
          </b-button>
         </b-col>
        </b-row>
      </b-card>

     <b-card bg-variant="white" v-if="stripe_plans['premium']"
         text-variant="black"  style="border-radius:1rem;max-width:30rem;"
         class="text-center">
        <b-card-text style="margin-bottom:4rem;">
          <b-row>
            <b-col>
              <h1 class="plan">
                PREMIUM
              </h1>
            </b-col>
          </b-row>  
          <b-row class="mb-4">
            <b-col>
              <span class="price">
                $49.99
              </span>
              <span class="per">
                /mo
              </span>
            </b-col>
          </b-row>  
          <b-row class="mb-1">
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> All of the Trial features with up to 400 interactive participants. </b-col>
          </b-row>
          <b-row>
            <b-col sm="2" class="check">done</b-col>
            <b-col sm="10" class="pbull"> Up to 50 breakout rooms and 10GB storage. </b-col>
          </b-row>
          <b-row class="mt-4 mb-1">
            <b-col class="pbull">
               <button title="support@videocafe.live"
                 style="border:none;background:none;cursor:auto;">
               <span>
                 <a href="mailto:support@videocafe.live">
                   Contact Us
                 </a>
               </span>
               <span>for more than 400 participants. </span>
               </button>
            </b-col>
          </b-row>
        </b-card-text>
        <b-row class="selrow" v-if="user.plan">
         <b-col>
          <b-button v-if="!user.plan.name || user.plan.name == 'cancel'"
           style="width:60%"
           variant="primary"
           @click="pselect('premium')"
          >
           Select
          </b-button>
          <b-button v-if="user.plan.name == 'trial' || user.plan.name == 'basic'"
           style="width:60%"
           variant="primary"
           @click="pselect('premium')"
          >
           Upgrade
          </b-button>
          <b-button v-if="user.plan.name == 'premium'"
           style="width:60%"
           variant="primary"
           disabled
          >
           <div> Your Current Plan </div>
          </b-button>
         </b-col>
        </b-row>
      </b-card>
    </b-card-group>
      </b-col>
    </b-row>

    <b-row v-if="at_step == 'room'" class="mt-4" align-h="center">
     <b-col sm="6">
      <b-card bg-variant="white" header="Choose Your Room Name"
         text-variant="black" style="border-radius:1rem"
         class="text-center">
        <b-card-text style="margin-bottom:4rem;">
           <b-form-input
             size="md"
             v-model="room_name"
             :disabled="!!user.room"
             :state="room_name_valid && !room_name_taken"
             placeholder="Room Name"
             v-on:keyup='updated_room_name'
             type="text">
           </b-form-input>
           <div style="color:red;"
              v-if="!room_name_valid">
              At least 4 lowercase letters, numbers, or hyphen
           </div>
           <div style="color:red;"
              v-if="room_name_taken">
              This room name is already taken.
           </div>           
           <div style="color:black;"
              v-if="user.room">
              This is the room already assigned to you.
           </div>           
        </b-card-text>
      </b-card>
        <b-button
          class="float-right mt-2"
          :disabled="!room_name_ready"
          variant="primary"
          @click="rselect()"
          >
           Next
        </b-button>
     </b-col>
    </b-row>

    <b-row v-if="at_step == 'user' && authenticated" class="mt-4" align-h="center">
     <b-col>
      <b-card-group deck>
       <b-card bg-variant="white"
          text-variant="black" style="border-radius:1rem"
          >
         <b-card-text style="margin-bottom:4rem;">
          <b-row>
           <b-col> You are currently signed in as </b-col>
          </b-row>
          <b-row>
           <b-col sm="3"> Email: </b-col>
           <b-col sm="9" style="font-weight:600"> {{ user.email }} </b-col>
          </b-row>
          <b-row>
           <b-col sm="3"> First: </b-col>
           <b-col sm="9" style="font-weight:600"> {{ user.first_name }} </b-col>
          </b-row>
          <b-row>
           <b-col sm="3"> Last: </b-col>
           <b-col sm="9" style="font-weight:600"> {{ user.last_name }} </b-col>
          </b-row>
          <div class="selrow">
           <b-row class="mt-2">
            <b-col style="font-size:0.8rem;"> Not the user you expected? </b-col>
           </b-row>
           <b-row>
            <b-col>
              <b-button size="sm"
               variant="danger"
               @click="signOut()"
              >
                Sign Out
              </b-button>
            </b-col>
           </b-row>
          </div>
         </b-card-text>
       </b-card>
       <b-card bg-variant="white"
          text-variant="black" style="border-radius:1rem"
          >
         <b-card-text style="margin-bottom:4rem;">
          <b-row v-if="!user.room">
           <b-col> Assign the following room </b-col>
          </b-row>
          <b-row v-if="!!user.room">
           <b-col> This is already your room </b-col>
          </b-row>
          <b-row>
            <b-col sm="1"> </b-col>
            <b-col sm="9" style="font-size:1.2rem;font-weight:600"> {{ room_name }} </b-col>
          </b-row>
         </b-card-text>
       </b-card>
       <b-card bg-variant="white"
          text-variant="black" style="border-radius:1rem"
          >
         <b-card-text style="margin-bottom:4rem;">
          <b-row v-if="true">
           <b-col>  Using the plan </b-col>
          </b-row>
          <b-row>
            <b-col sm="1"> </b-col>
            <b-col sm="9" style="font-size:1.2rem;font-weight:600"> {{ plan.dname }} </b-col>
          </b-row>
         </b-card-text>
       </b-card>
       </b-card-group>
        <b-button class="float-right mt-2"
          variant="primary"
          @click="uselect()"
          >
           Next
        </b-button>
     </b-col>
    </b-row>

    <b-row v-if="at_step == 'user' && !authenticated" class="mt-4" align-h="center">
     <b-col sm="6">
       <b-card bg-variant="white"
          text-variant="black" style="border-radius:1rem"
          >
         <b-card-text style="margin-bottom:4rem;text-align:center;">
              <div> Use a Social Login
              </div>
              <div class="tcon">
                <div class="tpart"
                  v-if="true">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:white; width:56px; height:56px;"
                    @click="ggSignIn"
                   >
                    <a>
                      <i class="google-icon__icon___1aU-8">
                        <svg width="16" height="16" viewBox="2 2 18 18">
                          <g
                            id="Google-Button"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="9-PATCH"
                              transform="translate(-608.000000, -160.000000)"
                            />
                            <g
                              id="btn_google_light_normal"
                              transform="translate(-1.000000, -1.000000)"
                            >
                              <g
                                id="button"
                                transform="translate(4.000000, 4.000000)"
                                filter="url(#filter-1)"
                              >
                                <g id="button-bg">
                                  <use fill="#FFFFFF" fill-rule="evenodd" />
                                  <use fill="none" />
                                  <use fill="none" />
                                  <use fill="none" />
                                </g>
                              </g>
                              <g
                                id="logo_googleg_48dp"
                                transform="translate(3, 3)"
                              >
                                <path
                                  d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"
                                  id="Shape"
                                  fill="#4285F4"
                                  Googl="true"
                                />
                                <path
                                  d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"
                                  id="Shape"
                                  fill="#34A853"
                                />
                                <path
                                  d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"
                                  id="Shape"
                                  fill="#FBBC05"
                                />
                                <path
                                  d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"
                                  id="Shape"
                                  fill="#EA4335"
                                />
                                <path
                                  d="M0,0 L18,0 L18,18 L0,18 L0,0 Z"
                                  id="Shape"
                                />
                              </g>
                              <g id="handles_square" />
                            </g>
                          </g>
                        </svg>
                      </i>
                    </a>
                  </b-button>
                </div>
                <div class="tpart"
                  v-if="true">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:#3b5998; width:56px; height:56px;"
                    @click="fbSignIn"
                  >
                    <a class="text-light" style="font-size:24px;">
                      <i class="typcn typcn-social-facebook"></i>&nbsp;&nbsp;
                    </a>
                  </b-button>
                </div>
                <div class="tpart"
                  v-if="true">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:white; padding:0; width:56px;"
                    @click="appleSignIn"
                  >
                    <img src="../../public/images/aplbl.svg"> </img>
                  </b-button>
                </div>
                <div class="tpart"
                  v-if="true">
                  <b-button
                    block
                    rounded
                    variant="outline-secondary"
                    style="background-color:white; padding:0; width:56px;  height:56px;"
                    @click="outlookSignIn"
                  >
                    <img src="../../public/images/outlook.svg"> </img>
                  </b-button>
                </div>
              </div>
           <div> Or, Vuemix Credentials
             <div>
                <b-form-input
                  type="email"
                  v-model="user.email"
                  placeholder="Enter email"
                ></b-form-input>
                <b-form-input
                  id="input-password"
                  type="password"
                  v-model="user.password"
                  placeholder="Enter password"
                ></b-form-input>
                <b-button block variant="primary"
                  @click="vuemixSignIn"
                 >
                  Sign In
                </b-button>
              </div>
           </div>
           <div> Or, Create a Vuemix Credentials
              <b-button block variant="primary"
                @click="vuemixCreate"
               >
                Create
              </b-button>              
           </div>
         </b-card-text>
       </b-card>
     </b-col>
    </b-row>

    <b-row v-if="at_step == 'pay'" class="mt-4" align-h="center">
     <b-col sm="6">
       <b-card bg-variant="white" header="Payment Information"
          text-variant="black" style="border-radius:1rem"
          >
         <b-card-text style="">
          <b-row>
           <b-col sm="3"> Room: </b-col>
           <b-col sm="9" style="font-weight:600"> {{ room_name }} </b-col>
          </b-row>
          <b-row>
           <b-col sm="3"> Plan: </b-col>
           <b-col sm="9" style="font-weight:600"> {{ plan.name }} </b-col>
          </b-row>
          <b-row v-if="plan.cost <= 0">
           <b-col sm="3"> Price: </b-col>
           <b-col sm="9" style="font-weight:600">
              Free
            </b-col>
          </b-row>
          <b-row v-if="plan.cost > 0 && !plan.credit">
           <b-col sm="3"> Price: </b-col>
           <b-col sm="9" style="font-weight:600">
              {{ "$"+(plan.cost/100).toFixed(2) }}
           </b-col>
          </b-row>
          <b-row v-if="plan.cost > 0 && plan.credit">
           <b-col sm="3"> Price: </b-col>
           <b-col sm="9" style="font-weight:600">
              <span> {{ "$"+((plan.cost - plan.credit)/100).toFixed(2) }} </span>
              <span style="font-size:0.7rem;">
                 ({{ "$"+(plan.cost/100).toFixed(2) }} - credit of {{ "$"+(plan.credit/100).toFixed(2) }})
              </span>
           </b-col>
          </b-row>
          
          <b-row v-if="!plan.cost > 0" class="mt-2">
            <b-col>
               30-day Free Trial
            </b-col>
          </b-row>
          <b-row v-if="plan.cost > 0" class="mt-2">
            <b-col>
                <b-input
                  type="text"
                  v-model="user.name"
                  placeholder="Billing Name"
                ></b-input>
            </b-col>            
          </b-row>
          <b-row v-if="plan.cost > 0" class="mt-1">
            <b-col>
                <b-input
                  type="text"
                  v-model="user.zipcode"
                  placeholder="Billing Zipcode"
                ></b-input>
            </b-col>            
          </b-row>
          <b-row v-if="plan.cost > 0" class="mt-2">
            <b-col>
              Payment Details
            </b-col>
          </b-row>
          <b-row v-if="plan.cost > 0">
           <b-col sm="2">
             <img class="ccard" v-if="stripe_ccbrand == 'mastercard'" src="../assets/img/mcard.svg"> </img>
             <img class="ccard" v-if="stripe_ccbrand == 'amex'" src="../assets/img/amex.svg"> </img>
             <img class="ccard" v-if="stripe_ccbrand == 'visa'" src="../assets/img/visa.png"> </img>
             <img class="ccard" v-if="stripe_ccbrand == 'discover'" src="../assets/img/disc.jpg"> </img>
           </b-col>
           <b-col sm="10">
            <div style="margin: 0.5rem 0;" id="cc-num"> </div>
            <div style="margin: 0.5rem 0;" id="cc-exp"> </div>
            <div style="margin: 0.5rem 0;" id="cc-cvc"> </div>
           </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
            </b-col>
            <b-col sm="10" style="font-size:0.7rem;color:red">
              {{ stripe_error }}
            </b-col>
          </b-row>
         </b-card-text>
       </b-card>
        <b-button class="float-right mt-2" v-if="!finalize_inprogress && plan.cost > 0"
          :variant="can_purchase?'primary':'outline-secondary'"
          :disabled="!can_purchase"
          @click="charge_and_finalize()"
          >
          Purchase
        </b-button>
        <b-button class="float-right mt-2" v-if="!finalize_inprogress && plan.cost <= 0"
          variant="primary"
          @click="trial_finalize()"
          >
          Start Trial
        </b-button>
        <div class="float-right mt-2" v-if="finalize_inprogress && !finalize_error"
          style="font-weight:600;">
          Processing...
        </div>
        <div class="float-right mt-2" v-if="finalize_inprogress && finalize_error"
          style="color:red;font-weight:600;">
          {{ finalize_error }}
        </div>
     </b-col>
    </b-row>

    <b-row v-if="at_step == 'done'" class="mt-4" align-h="center">
     <b-col sm="6">
       <b-card bg-variant="white"
          text-variant="black" style="border-radius:1rem"
          >
         <b-card-text>
          <b-row>
           <b-col sm="9" style="font-weight:600"> Purchase complete. </b-col>
          </b-row>
         </b-card-text>
       </b-card>
     </b-col>
    </b-row>


    <div style="position:fixed;bottom:0;right:0;">
      <a href="https://videocafe.live/">
        <img src="../assets/img/videocafe_logo_03.svg"
             style="object-fit:contain;width:10rem;"
         >
        </img>
      </a>
    </div>
    <div style="position:fixed;bottom:0;left:1rem;font-size:0.8rem;">
      {{ version }}
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "bah",
  data() {
    return {
      version: "",
      at_step: "plan",
      step_plan: "on",
      step_room:"off",
      step_user:"off",
      step_pay:"off",
      plan: {name:"",
             dname:"",
             cost:0},
      room_name: "",
      room_name_valid: false,
      room_name_taken: false,
      room_name_ready: false,
      user: {email:"",
             first_name:"",
             last_name:"",
             name: "", // Billing
             zipcode: "", // Billing
             room:"",             
             plan:null},
      authenticated: false,
      stripe_plans: [],
      stripe_ccbrand: null,
      stripe_error: "",
      stripe_ccnum_ok: false,
      stripe_ccexp_ok: false,
      stripe_cccvc_ok: false,
      finalize_inprogress: false,
      finalize_error: "",
    }
  },
  components: {
  },
  created() {
  },
  beforeDestroy() {
    let vue = this;
    window.clearTimeout(vue.auth_tid);  
    window.wss_clr_routes(window.vx,"bah");
  },
  computed: {
    can_purchase: function() {
      let vue = this;
      if (!vue.stripe_ccnum_ok) { return false; }
      if (!vue.stripe_ccexp_ok) { return false; }
      if (!vue.stripe_cccvc_ok) { return false; }
      if (!vue.user.name) { vue.stripe_error = "A billing name is required."; return false; }
      if (!vue.user.zipcode) { vue.stripe_error = "A billing zipcode is required."; return false; }
      vue.stripe_error = "";
      return true;
    }
  },
  mounted() {
    let vue = this;
    vue.version = vx.about.site_version;
    vue.jump_to('plan');
    vue.watch_auth();

    let url = vx.rq_endpoint+"/adm/account/plans/"+vx.subd+"/cfg";
    issue_http({nocred:true, type:"GET", url: url, done: function(s,r) {
        let j = to_json(r);
        if (!j || !j.stripe_key) {
           return;
        }
        vue.stripe_plans = j.stripe_plans;
        vue.stripe = Stripe(j.stripe_key);
        let elements = vue.stripe.elements();
        vue.stripe_ccnum = elements.create('cardNumber',{});
        vue.stripe_ccexp = elements.create('cardExpiry',{});
        vue.stripe_cccvc = elements.create('cardCvc',{});
        vue.stripe_ccnum.on('change', function(e) {
          if (!e.error) {
            vue.stripe_ccbrand = e.brand;
            vue.stripe_ccnum_ok = e.complete;
            vue.stripe_error = e.complete?"":"Your card number is incomplete.";
          } else {
            vue.stripe_ccbrand = "error";
            vue.stripe_error = e.error.message;
            vue.stripe_ccnum_ok = false;
          }
        });
        vue.stripe_ccexp.on('change', function(e) {
          if (!e.error) {
            vue.stripe_ccexp_ok = e.complete;
            vue.stripe_error = e.complete?"":"Your card's expiration data is incomplete";
          } else {
            vue.stripe_error = e.error.message;
            vue.stripe_ccexp_ok = false;
          }
        });
        vue.stripe_cccvc.on('change', function(e) {
          if (!e.error) {        
            vue.stripe_cccvc_ok = e.complete;
            vue.stripe_error = e.complete?"":"Your card's security code is incomplete.";
          } else {
            vue.stripe_error = e.error.message;
            vue.stripe_cccvc_ok = false;
          }
        });
    }});
  },
  updated() {
    let vue = this;
    if (vue.at_step == 'pay' && vue.plan.cost) {
       vue.stripe_ccnum.mount('#cc-num');
       vue.stripe_ccexp.mount('#cc-exp');
       vue.stripe_cccvc.mount('#cc-cvc');
    }
  },
  methods: {
    compute_left: function(plan) {
       plan.left = 0;
       if (!plan.charge_expires) { return; }
       plan.left = Math.round((plan.charge_expires -
                               (Date.now()/1000)) /
                              (24*3600));
       if (plan.left < 0) {
           plan.left = 0;
       }
    },
    open_wss: function() {
       let vue = this;
          window.wss_open(vx, {
            acc: vx.acc,
            uid: vx.user.id,
            room: vue.user.room,
            routes_id: "bah",
            routes: {
              auth_me: function() {
                if (vue.user.room) {
                  window.wss_send(vx, "auth_room", {
                    cred: vx.user.creds["myroom"]
                  });
                } else {
                  /* No room, no plan */
                  vue.user.plan = {};
                }
              },
              auth_room: function(msg) {
                if (msg.data == "denied") {
                  console.warn("auth_room failed");
                  return;
                }
                console.log("after_auth",vue.after_auth_room,vue.finalized_plan);
                if (vue.after_auth_room == "get_plan") {                  
                   window.wss_send(window.vx, "get_room_ctrl", {});
                   vue.after_auth_room = null;
                } else if (vue.after_auth_room == "set_plan" &&
                           vue.finalized_plan) {
                   window.wss_send(window.vx, "set_room_plan",
                                   vue.finalized_plan);
                   vue.after_auth_room = null;
                }
              },
              room_ctrl: function(msg) {
                if (msg.data.plan) {
                   let plan = msg.data.plan || {};
                   vue.user.plan = plan;
                   vue.compute_left(vue.user.plan);
                } else {
                  vue.user.plan = {};
                }
              },
              set_room_plan: function(msg) {
                if (msg.data.error) {
                   vue.stripe_error = msg.data.error;
                   if (msg.data.retry) {
                     vue.stop_finalize();
                   } else {
                     vue.finalize_error = "Stripe charge failed.";
                   }
                   return;
                }
                if (msg.data.plan) {
                   let plan = msg.data.plan || {};
                   vue.user.plan = plan;
                   vue.compute_left(vue.user.plan);
                }
                if (vue.finalized_plan && vue.finalized_plan.trans.id) {
                   if (!msg.data.plan || !msg.data.trans ||
                       msg.data.trans.id != vue.finalized_plan.trans.id) {
                       console.warn("Transaction failed",msg.data);
                       return;
                   } else {
                       vue.finalized_plan = null;
                       vue.jump_to('done');
                       if (vue.user.plan.name != "cancel") {
                         setTimeout(function() {
                           vue.go_to_room();
                         }, 1000);
                       }
                   }
                }
              }
            }
          });
    },
    watch_auth: function() {
      let vue = this;
      let cnt = 0;
      window.clearTimeout(vue.auth_tid);
      vue.authenticated = false;
      vue.auth_tid = setInterval(function() {
        cnt++;
        /* First check if already signed in. If not then wait for signal */
        if (cnt > 1) {
           let tm = getLocal('vx_alldone');
           if (!tm || (((Date.now()/1000)-10) > (+tm))) {
              //console.log((Date.now()/1000)-10,(+tm));
              return;
           }
        }
        vx_api.getSelf(window.vx).then(self_res => {
          window.clearTimeout(vue.auth_tid);
          vue.$user.set(
            Object.assign({
              role: "authenticatedUser"
            },
            self_res)
          );
          console.log("Auth ok");
          eraseLocal('vx_alldone');
          vue.authenticated = true;
          vue.user.email = vue.$parent.currentUser.email;
          vue.user.first_name = vue.$parent.currentUser.first_name;
          vue.user.last_name = vue.$parent.currentUser.last_name;
          vue.user.room = vue.$parent.currentUser.nick;

          if (vue.user.room /* && vue.room_name != vue.user.room */) {
            vue.room_name = vue.user.room;
            vue.room_name_valid = true;
            vue.room_name_taken = false;
            vue.room_name_ready = true;
            if (vue.at_step != 'plan') {
              /* Already has a room, restart */
              vue.jump_to('plan');
            }
          } else if (vue.at_step == 'user') {
            vue.jump_to('user');
          }
          //if (vue.user.room) {
          //  window.vx_set_room(vx, vx.acc, vue.user.room);
          //}

          vue.after_auth_room = "get_plan";
          vue.open_wss();
        }).catch(error => {
          console.log(error);
          /* Not signed in, Assume no plan */
          vue.user.plan = {};
        });
      }, 1000);
    },
    jump_to: function(step) {
      let vue = this;
      if (step == "plan") {
        vue.at_step = "plan";
        vue.step_plan = "on";
        vue.step_room = "off";
        vue.step_user = "off";
        vue.step_pay = "off";      
      } else if (step == "room") {
        vue.at_step = "room";
        vue.step_plan = "on";
        vue.step_room = "on";
        vue.step_user = "off";
        vue.step_pay = "off";
      } else if (step == "user") {
        vue.at_step = "user";
        vue.step_plan = "on";
        vue.step_room = "on";
        vue.step_user = "on";
        vue.step_pay = "off";
      } else if (step == "pay") {
        vue.at_step = "pay";
        vue.step_plan = "on";
        vue.step_room = "on";
        vue.step_user = "on";
        vue.step_pay = "on";
      } else if (step == "done") {
        vue.at_step = "done";
        vue.step_plan = "off";
        vue.step_room = "off";
        vue.step_user = "off";
        vue.step_pay = "off";
      }
    },
    usr_jump_to: function(step) {
      let vue = this;
      if (vue.finalize_inprogress) {
        return;
      }
      if (vue.at_step == "plan") {
        return;
      } else if (vue.at_step == "room") {
        if (step == "pay") { return; }
        if (step == "user") { return; }
      } else if (vue.at_step == "user") {
        if (step == "pay") { return; }
      } else if (vue.at_step == "pay") {
      }
      vue.jump_to(step);
    },
    pselect: function(plan) {
      let vue = this;
      vue.jump_to('room');
      vue.plan.name = plan;
      vue.plan.credit = 0;
      if (plan == "trial") {
        vue.plan.dname = "Trial";
        vue.plan.cost = 0;
      } else if (plan == "basic") {
        vue.plan.dname = "Basic";
        vue.plan.cost = 1199;
      } else if (plan == "premium") {
        vue.plan.dname = "Premium";
        vue.plan.cost = 4999;
        if (vue.user.plan.name == "basic") {
           let am = Math.round(1199 * (vue.user.plan.left / 30));
           if (am < 1) { am = 0; }
           vue.plan.credit = am;
        }
      }
    },
    updated_room_name: function() {
      let vue = this;
      vue.room_name_valid = false;
      vue.room_name_taken = false;
      vue.room_name_ready = false;

      vue.room_name = vue.room_name.toLowerCase();
      if (vue.room_name.length < 4) {
         vue.room_name_valid = false;
         return;
      }
      let m = vue.room_name.match(/^[a-z0-9\-]+$/);
      if (!m) {
         vue.room_name_valid = false;
         return;
      }

      vue.room_name_valid = true;
      window.clearTimeout(vue.room_tid);
      vue.room_tid = setTimeout(function() {
        let url = ("//"+vx.subd+".vuemix.com/api/v2/users/nick/" +
                   vue.room_name);
        issue_http({
          url: url,
          type: "GET",
          contentType: "application/json",
          done: function(status, data) {
            let j = to_json(data);
            if (status != 200 || j.status != 200) {
              vue.room_name_taken = true;
            } else {
              vue.room_name_ready = true;
            }
          }
        });       
      }, 500);
    },
    rselect: function() {
      let vue = this;
      vue.jump_to('user');
    },
    ggSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let base = "https://mapp.vuemix.com";
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
         base +
         "/mm/loginredirect.html?action=google_auth&acc=" +
         host;
      LoginURL += "&resume="+encodeURIComponent("/alldone.html");
      window.open(LoginURL, 'Authenticate with Google', "height=600,width=500");
    },
    fbSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let base = "https://mapp.vuemix.com";
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
         base +
         "/mm/loginredirect.html?action=facebook_auth&acc=" +
         host;
      LoginURL += "&resume="+encodeURIComponent("/alldone.html");
      window.open(LoginURL, 'Authenticate with Facebook', "height=600,width=500");
    },
    appleSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let base = "https://mapp.vuemix.com";
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
         base +
         "/mm/loginredirect.html?action=apple_auth&acc=" +
         host;
      LoginURL += "&resume="+encodeURIComponent("/alldone.html");
      window.open(LoginURL, 'Authenticate with Apple', "height=600,width=500");
    },
    outlookSignIn: function() {
      let vue = this;
      let host = window.location.host;
      let base = "https://mapp.vuemix.com";
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
         base +
         "/mm/loginredirect.html?action=outlook_auth&acc=" +
         host;
      LoginURL += "&resume="+encodeURIComponent("/alldone.html");
      window.open(LoginURL, 'Authenticate with Outlook', "height=600,width=500");
    },
    vuemixSignIn: function() {
      let vue = this;
      vue.vuemix_signin_failed = false;
      vx_api.signIn(window.vx, vue.user)
      .then(data => {
         setLocal("vx_alldone", (Date.now()/1000));
      })
      .catch(error => {
        vue.vuemix_signin_failed = true;
      });
    },
    signOut: function() {
      let vue = this;
      vx_api.signOut(window.vx)
      .then(data => {
        console.log("signed out");
        eraseLocal('vx_alldone');
        vx.user = {};
        if (vue.room_name == vue.user.room) {
          vue.room_name = "";
        }        
        vue.user.email = "";
        vue.user.password = "";
        vue.user.room = "";
        vue.user.first_name = "";
        vue.user.last_name = "";
        vue.user.plan = null;
        if (!vue.room_name) {
          vue.jump_to("room");
          vue.room_name_ready = false;
          vue.room_name_valid = false;
        }
        vue.watch_auth();
      })
      .catch(error => {
      });
    },
    vuemixCreate: function() {
      let url = this.$router.resolve({name: 'register'}).href;
      window.open(url, 'Register Vuemix', "height=600,width=500");
    },
    uselect: function() {
      let vue = this;
      vue.jump_to('pay');
    },
    start_finalize: function() {
      let vue = this;
      vue.finalize_inprogress = true;
      vue.step_plan="done";
      vue.step_room = "done";
      vue.step_user = "done";
      vue.step_pay = "done";
    },
    stop_finalize: function() {
      let vue = this;
      vue.finalize_inprogress = false;
      vue.step_plan = "on";
      vue.step_room = "on";
      vue.step_user = "on";
      vue.step_pay = "on";
    },
    trial_finalize: function() {
      let vue = this;

      vue.finalized_plan = {
        subd: vx.subd,
        plan: { name: "trial",
              },
        trans: { id: "trial30",
               },
      };

      vue.start_finalize();
      if (!vue.user.room) {
        window.api_user_update(window.vx, {
          nick: ""+vue.room_name,
        }, function() {
          vx_api.getSelf(window.vx).then(self_res => {
            vue.user.room = vue.room_name;
            //window.vx_set_room(vx, vx.acc, vue.room_name);
            vue.after_auth_room = "set_plan";
            vue.open_wss();
          });
        });
      } else {
        window.wss_send(window.vx, "set_room_plan",
                        vue.finalized_plan);
      }
    },
    charge_and_finalize: function() {
      let vue = this;
      let opt = {};
      if (!vue.user.name || !vue.user.zipcode) {
        return;
      }
      opt.address_zip = vue.user.zipcode;
      vue.start_finalize();
      vue.stripe.createToken(vue.stripe_ccnum, opt).then(rsp => {
        if (!rsp || !rsp.token || !rsp.token.id) {
          vue.stripe_error = "Charge failed.";
          if (rsp.error && rsp.error.message) {
             vue.stripe_error += rsp.error.message;
          }
          vue.stop_finalize();
          return;
        }
        vue.finalized_plan = {
          subd: vx.subd,
          plan: { name: vue.plan.name,
                },
          trans: { id: rsp.token.id,
                  name: vue.user.name,
                  zipcode: vue.user.zipcode,
                 },
        };

        if (!vue.user.room) {
          window.api_user_update(window.vx, {
            nick: ""+vue.room_name,
          }, function() {
            vx_api.getSelf(window.vx).then(self_res => {
              vue.user.room = vue.room_name;
              //window.vx_set_room(vx, vx.acc, vue.room_name);
              vue.after_auth_room = "set_plan";
              vue.open_wss();
            });
          });
        } else {
          window.wss_send(window.vx, "set_room_plan",
                          vue.finalized_plan);
        }

      }).catch(e => {
        vue.stripe_error = "Charge failed.";
        vue.stop_finalize();
        console.warn("createToken error",e);
      });

      return;
    },
    go_to_room() {
      //let url = this.$router.resolve({name: 'home'}).href;
      window.location.href = "/mm";
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}

div[step="on"] > svg {
  fill:#000020;
  cursor:pointer;
}
div[step="on"] > div {
  color:white;
  cursor:pointer;
}
div[step="off"] > svg {
  fill:#dddded;
  cursor:not-allowed;
}
div[step="off"] > div {
  color:white;
  cursor:not-allowed;
}
div[step="done"] > svg {
  fill:#dddded;
  cursor:not-allowed;
}
div[step="done"] > div {
  color:transparent;
  cursor:not-allowed;
}

.step_txt {
  position:absolute;
  top:5px;
  left:30%;
  padding:0;
  font-size:1.125rem;
  line-height:1.75rem;
  letter-spacing: 0.025em;
  font-weight:500;
}
.check {
 font-family: "Material Icons";
 font-weight:600;
 font-size: 1.25rem;
 color:green;
 padding:0;
 margin:0;
}
.plan {
  color:black;
  font-size:1.25rem;
  line-height:1.75rem;
  letter-spacing: 0.025em;
  font-weight:500;
}
.price {
  font-size:1.500rem;
  line-height:2.00rem;
  font-weight:500;
}
.per {
  font-size:0.875rem;
  line-height:1.25rem;
  font-weight:500;
}
.pbull {
  text-align:left;
}
.selrow {
 position:absolute;
 bottom:1rem;
 width:100%;
 left-margin:33%;
}

.tcon {
  display:flex;
  justify-content: space-around;
  margin: 0 10%;
}
.tpart {
  flex: 0 1 64px;
}

.ccard {
  object-fit: contain;
  max-width:100%;
}

</style>
